import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AlignStrategy } from '@progress/kendo-popup-common';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { SAFETY_RECOMMENDATIONS_ROUTE, SAFETY_RECOMMENDATIONS_SEARCH_ROUTE } from '@core/app.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {

  searchForm: FormGroup;

  public anchorAlign: AlignStrategy = { horizontal: 'right', vertical: 'bottom' };
  public popupAlign: AlignStrategy = { horizontal: 'left', vertical: 'top' };
  public showAdvancedSearch = false;
  public selectedLang: string;

  languages = [
    { id: 'en', name: 'English' }
  ];

  constructor(
    private readonly router: Router,
    private readonly fb: FormBuilder
  ) {
    this.resetSearchForm(true);
    this.selectedLang = 'en';
  }

  public advancedSearchToggle(): void {
    this.showAdvancedSearch = !this.showAdvancedSearch;
  }

  public keyDownFunction(event): void {
    if (event.keyCode === 13) {
      this.onSearchClick();
    }
  }

  onSearchClick(): void {
    if (this.searchForm.get('searchTerm').value != null) {
      this.showAdvancedSearch = false;

      if (this.searchForm.get('searchTerm').value === '') {
        this.redirectToHome();
      } else {
        this.router.navigate([`/${SAFETY_RECOMMENDATIONS_ROUTE}/${SAFETY_RECOMMENDATIONS_SEARCH_ROUTE}`], {
          queryParams: {searchTerm: this.searchForm.get('searchTerm').value}
        });
      }
    }
  }

  onCheckboxChange(e: any, value: string): void {
    const checkArray = this.searchForm.get('typeIn').value;

    if (e.checked) {
      checkArray.push(value);
    } else {
      checkArray.splice(checkArray.indexOf(value), 1);
    }
  }

  resetSearchForm(preventSearch?: boolean): void {
    this.searchForm = this.fb.group({
      searchTerm: new FormControl('')
    });

    if (!preventSearch) {
      this.onSearchClick();
    }
  }

  redirectToHome(): void {
    sessionStorage.clear();
    this.resetSearchForm(true);
    if (this.router.url === '/' + SAFETY_RECOMMENDATIONS_ROUTE) {
      location.reload();
    } else {
      this.router.navigate([SAFETY_RECOMMENDATIONS_ROUTE]);
    }
  }

  openInfoPDF(): void {
    window.open('assets/docs/important information.pdf', '_blank');
  }

  showClearButton(): boolean {
    return this.searchForm && this.searchForm.get('searchTerm') &&
      this.searchForm.get('searchTerm').value != null && this.searchForm.get('searchTerm').value !== '';
  }
}
